import { DateRangeFilter, TenantAndTeamFilter } from '../../Shared';
import { CallDurationFilter } from '../CallDurationFilter';
import { CallOutcomeFilter } from '../CallOutcomeFilter';
import { SearchFilter } from '../SearchFilter';

const MAX_AVAILABLE_DATE_RANGE = 13;

const handleDateRange = (startDate, endDate, cb) => {
  if (!endDate) {
    cb(endDate);
    return;
  }

  const diffMs = endDate - startDate;
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= MAX_AVAILABLE_DATE_RANGE) {
    cb(endDate);
    return;
  }

  alert('The available date range is 14 days. Please, try again.');
};

export const FiltersPanel = ({
  initialCallDuration,
  filters,
  onChangeFilters,
}) => {
  return (
    <>
      <SearchFilter
        key={filters.search}
        search={filters.search}
        onChangeSearch={onChangeFilters}
      />
      <TenantAndTeamFilter
        callerIds={filters.callerIds}
        onChangeCallerIds={onChangeFilters}
      />
      <DateRangeFilter
        startDate={filters.startDate}
        endDate={filters.endDate}
        onChangeDateRange={onChangeFilters}
        handleDateRange={handleDateRange}
      />
      <CallOutcomeFilter
        callOutcome={filters.callOutcome}
        onChangeCallOutcome={onChangeFilters}
      />
      <CallDurationFilter
        initialCallDuration={initialCallDuration}
        callDuration={filters.callDuration}
        onChangeCallDuration={onChangeFilters}
      />
    </>
  );
};
